<template>
  <div
    data-testid="ds-modal-body"
    class="ds-modal-body"
    :class="{ 'ds-modal-body-form': isForm }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";

defineOptions({
  name: "DsModalBody",
});

const isForm = inject("isForm") as boolean;
</script>

<style lang="scss" scoped>
.ds-modal-body {
  @apply overflow-y-auto overflow-x-hidden flex-1 p-5;

  &.ds-modal-body-form {
    @apply pb-0;
  }
}
</style>
